import objectPath from "object-path";
import { bindActionCreators } from "redux";
import { call, put, select, take } from "redux-saga/effects";

import * as apiCaller from "../../api/apiCaller";
import datetimeHelper from "../../helper/datetime-helper";
import AppError from "./../../ultis/AppError";

export const GET_LIST_REPORT_AGENT = "GET_LIST_REPORT_AGENT";
export const GET_LIST_REPORT_AGENT_ERROR = "GET_LIST_REPORT_AGENT_ERROR";
export const GET_LIST_REPORT_AGENT_SUCCESS = "GET_LIST_REPORT_AGENT_SUCCESS";

export const GET_LIST_REPORT_AGENT_BY_HOUR = "GET_LIST_REPORT_AGENT_BY_HOUR";
export const GET_LIST_REPORT_AGENT_BY_HOUR_ERROR =
  "GET_LIST_REPORT_AGENT_BY_HOUR_ERROR";
export const GET_LIST_REPORT_AGENT_BY_HOUR_SUCCESS =
  "GET_LIST_REPORT_AGENT_BY_HOUR_SUCCESS";

export const GET_LIST_REPORT_AGENT_BY_DATE = "GET_LIST_REPORT_AGENT_BY_DATE";
export const GET_LIST_REPORT_AGENT_BY_DATE_ERROR =
  "GET_LIST_REPORT_AGENT_BY_DATE_ERROR";
export const GET_LIST_REPORT_AGENT_BY_DATE_SUCCESS =
  "GET_LIST_REPORT_AGENT_BY_DATE_SUCCESS";

export const GET_REPORT_AGENT_DETAIL = "GET_REPORT_AGENT_DETAIL";
export const GET_REPORT_AGENT_DETAIL_SUCCESS =
  "GET_REPORT_AGENT_DETAIL_SUCCESS";
export const GET_REPORT_AGENT_DETAIL_ERROR = "GET_REPORT_AGENT_DETAIL_ERROR";

export const GET_LIST_REPORT_AGENT_BY_DATE_DETAIL =
  "GET_LIST_REPORT_AGENT_BY_DATE_DETAIL";
export const GET_LIST_REPORT_AGENT_BY_DATE_DETAIL_SUCCESS =
  "GET_LIST_REPORT_AGENT_BY_DATE_DETAIL_SUCCESS";
export const GET_LIST_REPORT_AGENT_BY_DATE_DETAIL_ERROR =
  "GET_LIST_REPORT_AGENT_BY_DATE_DETAIL_ERROR";

export const GET_REPORT_AGENT_PERFORMENCE = "GET_REPORT_AGENT_PERFORMENCE";
export const GET_REPORT_AGENT_PERFORMENCE_SUCCESS =
  "GET_REPORT_AGENT_PERFORMENCE_SUCCESS";
export const GET_REPORT_AGENT_PERFORMENCE_ERROR =
  "GET_REPORT_AGENT_PERFORMENCE_ERROR";

export const GET_REPORT_AGENT_CALL_DURATION = "GET_REPORT_AGENT_CALL_DURATION";
export const GET_REPORT_AGENT_CALL_DURATION_SUCCESS =
  "GET_REPORT_AGENT_CALL_DURATION_SUCCESS";
export const GET_REPORT_AGENT_CALL_DURATION_ERROR =
  "GET_REPORT_AGENT_CALL_DURATION_ERROR";

export const REPORT_AGENT_AND_GROUP_PERFORMANCE =
  "REPORT_AGENT_AND_GROUP_PERFORMANCE";
export const REPORT_AGENT_AND_GROUP_PERFORMANCE_SUCCESS =
  "REPORT_AGENT_AND_GROUP_PERFORMANCE_SUCCESS";
export const REPORT_AGENT_AND_GROUP_PERFORMANCE_ERROR =
  "REPORT_AGENT_AND_GROUP_PERFORMANCE_ERROR";

export const REPORT_AGENT_INBOUND = "REPORT_AGENT_INBOUND";
export const REPORT_AGENT_INBOUND_ERROR = "REPORT_AGENT_INBOUND_ERROR";
export const REPORT_AGENT_INBOUND_SUCCESS = "REPORT_AGENT_INBOUND_SUCCESS";
/**
 * Reducer
 */

const initialState = {
  report: [],
  reportAgentByHour: [],
  reportAgentByDate: [],
  error: false,
  loading: false,
  reportDetail: {},
  reportAgentByDateDetail: null,
  reportAgentPerformence: [],
  reportAgentCallDuration: [],
  reportAgentAndGroup: [],
  reportAgentInbound: [],
};

export const agentReducer = (state = initialState, action) => {
  switch (action.type) {
    //get list
    case GET_LIST_REPORT_AGENT:
      return {
        ...state,
        loading: true,
      };
    case GET_LIST_REPORT_AGENT_SUCCESS:
      return {
        ...state,
        loading: false,
        report: action.payload,
      };
    case GET_LIST_REPORT_AGENT_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };
    //get list agent hour
    case GET_LIST_REPORT_AGENT_BY_HOUR:
      return {
        ...state,
        loading: true,
      };
    case GET_LIST_REPORT_AGENT_BY_HOUR_SUCCESS:
      return {
        ...state,
        loading: false,
        reportAgentByHour: action.payload,
      };
    case GET_LIST_REPORT_AGENT_BY_HOUR_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };
    //get list agent outbound
    case GET_LIST_REPORT_AGENT_BY_DATE:
      return {
        ...state,
        loading: true,
      };
    case GET_LIST_REPORT_AGENT_BY_DATE_SUCCESS:
      return {
        ...state,
        loading: false,
        reportAgentByDate: action.payload,
      };
    case GET_LIST_REPORT_AGENT_BY_DATE_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };
    //get detail
    case GET_REPORT_AGENT_DETAIL:
      return {
        ...state,
        loading: true,
      };
    case GET_REPORT_AGENT_DETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        reportDetail: action.payload,
      };
    case GET_REPORT_AGENT_DETAIL_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };
    //get report by date detail
    case GET_LIST_REPORT_AGENT_BY_DATE_DETAIL:
      return {
        ...state,
        loading: true,
      };
    case GET_LIST_REPORT_AGENT_BY_DATE_DETAIL_SUCCESS:
      return {
        ...state,
        reportAgentByDateDetail: action.payload,
        loading: false,
      };
    case GET_LIST_REPORT_AGENT_BY_DATE_DETAIL_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };
    //get report agent performence
    case GET_REPORT_AGENT_PERFORMENCE:
      return {
        ...state,
        loading: true,
      };
    case GET_REPORT_AGENT_PERFORMENCE_SUCCESS:
      return {
        ...state,
        reportAgentPerformence: action.payload,
        loading: false,
      };
    case GET_REPORT_AGENT_PERFORMENCE_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };
    //get agent call duration
    case GET_REPORT_AGENT_CALL_DURATION:
      return {
        ...state,
        loading: true,
      };
    case GET_REPORT_AGENT_CALL_DURATION_SUCCESS:
      return {
        ...state,
        reportAgentCallDuration: action.payload,
        loading: false,
      };
    case GET_REPORT_AGENT_CALL_DURATION_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };

    case REPORT_AGENT_AND_GROUP_PERFORMANCE:
      return {
        ...state,
        loading: true,
      };
    case REPORT_AGENT_AND_GROUP_PERFORMANCE_SUCCESS:
      return {
        ...state,
        reportAgentAndGroup: action.payload,
        loading: false,
      };
    case REPORT_AGENT_AND_GROUP_PERFORMANCE_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };
    //report agent inbound
    case REPORT_AGENT_INBOUND:
      return {
        ...state,
        loading: true,
      };
    case REPORT_AGENT_INBOUND_SUCCESS:
      return {
        ...state,
        reportAgentInbound: action.payload,
        loading: false,
      };
    case REPORT_AGENT_INBOUND_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };
    default:
      return state;
  }
};

/**
 * Action
 */
export const getListReportAgent = (from, to) => ({
  type: GET_LIST_REPORT_AGENT,
  data: {
    from,
    to,
  },
});

export const getListReportAgentByHour = (agentId, date) => ({
  type: GET_LIST_REPORT_AGENT_BY_HOUR,
  data: {
    agentId,
    date,
  },
});

export const getListReportAgentByDate = (agentId, from, to) => ({
  type: GET_LIST_REPORT_AGENT_BY_DATE,
  data: {
    agentId,
    from,
    to,
  },
});

export const getAgentReportDetail = (id) => ({
  type: GET_REPORT_AGENT_DETAIL,
  data: {
    id,
  },
});

export const getAgentReportByDateDetail = (date) => ({
  type: GET_LIST_REPORT_AGENT_BY_DATE_DETAIL,
  data: {
    date,
  },
});

export const getListReportAgentPerformence = (from, to) => ({
  type: GET_REPORT_AGENT_PERFORMENCE,
  data: {
    from,
    to,
  },
});

export const getListReportAgentAndGroupPerformence = (
  from,
  to,
  agentId,
  agentGroupId
) => ({
  type: REPORT_AGENT_AND_GROUP_PERFORMANCE,
  data: {
    from,
    to,
    agentId,
    agentGroupId,
  },
});

export const getReportAgentInbound = (from, to, number, groupId) => ({
  type: REPORT_AGENT_INBOUND,
  data: {
    from,
    to,
    number,
    groupId,
  },
});

export const getAgentCallDuration = (from, to) => ({
  type: GET_REPORT_AGENT_CALL_DURATION,
  data: {
    from,
    to,
  },
});

export const mapActionsToProps = (dispatch) => {
  return bindActionCreators(
    {
      getListReportAgent,
      getListReportAgentByHour,
      getListReportAgentByDate,
      getAgentReportDetail,
      getAgentReportByDateDetail,
      getListReportAgentPerformence,
      getAgentCallDuration,
      getListReportAgentAndGroupPerformence,
      getReportAgentInbound,
    },
    dispatch
  );
};

/**
 * Apis
 */

const getListReportAgentApi = (from, to) => {
  return apiCaller.getData("/cloud-pbx/CallCenterServices/report", {
    from,
    to,
  });
};

const getListReportAgentByHourApi = (agentId, date) => {
  return apiCaller.getData("/cloud-pbx/outbound-call/report-agent-by-hours", {
    agentId,
    date,
  });
};

const getListReportAgentByDateApi = (agentId, from, to) => {
  return apiCaller.getData("/cloud-pbx/outbound-call/report-agent-by-date", {
    agentId,
    from,
    to,
  });
};

const getListReportAgentPerformenceApi = (from, to) => {
  return apiCaller.getData("/cloud-pbx/outbound-call/report-agent-peformance", {
    from,
    to,
  });
};

const getListReportAgentAndGroupPerformenceApi = (
  from,
  to,
  agentId,
  agentGroupId
) => {
  return apiCaller.getData(
    "/cloud-pbx/outbound-call/report-peformance-by-team-and-agent",
    { from, to, agentId, agentGroupId }
  );
};

const getAgentCallDurationApi = (from, to) => {
  return apiCaller.getData(
    "/cloud-pbx/outbound-call/report-agent-call-duration",
    { from, to }
  );
};

const reportAgentInboundApi = (from, to, number, groupId) => {
  return apiCaller.getData("/cloud-pbx/inbound-call/report-agent-peformance", {
    from,
    to,
    number,
    groupId,
  });
};
/**
 * sagas
 */

let inbound = [];
let outbound = [];

export const getListReportAgentFlow = function* () {
  while (true) {
    const action = yield take(GET_LIST_REPORT_AGENT);
    try {
      const res = yield call(
        getListReportAgentApi,
        action.data.from,
        action.data.to
      );
      res.data.forEach((data) => {
        inbound = { ...data.agent, ...data.inboundCalls };
        outbound = { ...data.agent, ...data.outboundCalls };
      });
      yield put({
        type: GET_LIST_REPORT_AGENT_SUCCESS,
        payload: { ...res.data },
      });
    } catch (error) {
      yield put({ type: GET_LIST_REPORT_AGENT_ERROR, error });
    }
  }
};

export const getListReportAgentByHourFlow = function* () {
  while (true) {
    const action = yield take(GET_LIST_REPORT_AGENT_BY_HOUR);
    try {
      const res = yield call(
        getListReportAgentByHourApi,
        action.data.agentId,
        action.data.date
      );
      yield put({
        type: GET_LIST_REPORT_AGENT_BY_HOUR_SUCCESS,
        payload: {
          ...res.data,
        },
      });
    } catch (error) {
      yield put({
        type: GET_LIST_REPORT_AGENT_BY_HOUR_ERROR,
        error,
      });
    }
  }
};

export const getListReportAgentOutboundFlow = function* () {
  while (true) {
    const action = yield take(GET_LIST_REPORT_AGENT_BY_DATE);
    try {
      const res = yield call(
        getListReportAgentByDateApi,
        action.data.agentId,
        action.data.from,
        action.data.to
      );
      yield put({
        type: GET_LIST_REPORT_AGENT_BY_DATE_SUCCESS,
        payload: {
          ...res.data,
        },
      });
    } catch (error) {
      yield put({
        type: GET_LIST_REPORT_AGENT_BY_DATE_ERROR,
        error,
      });
    }
  }
};

export const getAgentReportDetailFlow = function* () {
  while (true) {
    const action = yield take(GET_REPORT_AGENT_DETAIL);
    const reportAgent = yield select((state) => state.reportAgent.report);
    if (reportAgent.length) {
      const _reportAgent = reportAgent.filter(
        (c) => c.agent.agentId == action.data.id
      );
      if (_reportAgent.length == 1) {
        const reportAgentDetail = _reportAgent[0];
        yield put({
          type: GET_REPORT_AGENT_DETAIL_SUCCESS,
          payload: reportAgentDetail,
        });
        continue;
      }
    }
    try {
      const res = yield call(getListReportAgentApi);
      yield put({
        type: GET_LIST_REPORT_AGENT_SUCCESS,
        payload: { ...res.data },
      });
      const _reportAgent = res.data.filter(
        (c) => c.agent.agentId == action.data.id
      );
      if (_reportAgent.length == 1) {
        const reportAgentDetail = _reportAgent[0];
        yield put({
          type: GET_REPORT_AGENT_DETAIL_SUCCESS,
          payload: reportAgentDetail,
        });
        continue;
      } else {
        throw new AppError(null, "Không tìm thấy bản ghi này");
      }
    } catch (error) {
      yield put({ type: GET_REPORT_AGENT_DETAIL_ERROR, error });
    }
  }
};

export const getAgentReportByDateDetailFlow = function* () {
  while (true) {
    const action = yield take(GET_LIST_REPORT_AGENT_BY_DATE_DETAIL);
    const reportAgent = yield select(
      (state) => state.reportAgent.reportAgentByDate
    );
    if (reportAgent.length) {
      const _reportAgent = reportAgent.filter(
        (c) => c.date == action.data.date
      );
      if (_reportAgent.length == 1) {
        const reportAgentDetail = _reportAgent[0];
        yield put({
          type: GET_LIST_REPORT_AGENT_BY_DATE_DETAIL_SUCCESS,
          payload: reportAgentDetail,
        });
        continue;
      }
    }
    try {
      const res = yield call(getListReportAgentByDateApi);
      yield put({
        type: GET_LIST_REPORT_AGENT_BY_DATE,
        payload: { ...res.data },
      });
      const _reportAgent = res.data.filter((c) => c.date == action.data.date);
      if (_reportAgent.length == 1) {
        const reportAgentDetail = _reportAgent[0];
        yield put({
          type: GET_LIST_REPORT_AGENT_BY_DATE_DETAIL_SUCCESS,
          payload: reportAgentDetail,
        });
        continue;
      } else {
        throw new AppError(null, "Không tìm thấy bản ghi này");
      }
    } catch (error) {
      yield put({ type: GET_LIST_REPORT_AGENT_BY_DATE_DETAIL_ERROR, error });
    }
  }
};

export const getListReportAgentPerformenceFlow = function* () {
  while (true) {
    const action = yield take(GET_REPORT_AGENT_PERFORMENCE);
    try {
      const res = yield call(
        getListReportAgentPerformenceApi,
        action.data.from,
        action.data.to
      );
      const data = res.data.sort(function (a, b) {
        var n = Date.parse(b.date) - Date.parse(a.date);
        if (n != 0) {
          return n;
        }
        var m = b.agent.group.localeCompare(a.agent.group);
        if (m != 0) {
          return m;
        }
        return a.agent.code - b.agent.code;
      });

      const reportGroups = {
        date: {
          fields: ["date"],
        },

        dateNTeam: {
          fields: ["date", "agent.group"],
        },
      };
      data.forEach((item) => {
        item.totalTalkingTime =
          item.totalTalkingTime != null
            ? datetimeHelper.secondToHHMMSS(item.totalTalkingTime)
            : item.totalTalkingTime;
        item.acd =
          item.acd != null ? datetimeHelper.secondToHHMMSS(item.acd) : item.acd;
        item.minWrapupTime =
          item.minWrapupTime != null
            ? datetimeHelper.msToTime(item.minWrapupTime)
            : item.minWrapupTime;
        item.maxWrapupTime =
          item.maxWrapupTime != null
            ? datetimeHelper.msToTime(item.maxWrapupTime)
            : item.maxWrapupTime;
        item.avgWrapupTime =
          item.avgWrapupTime != null
            ? datetimeHelper.msToTime(item.avgWrapupTime)
            : item.avgWrapupTime;
        item.totalBreakTime =
          item.totalBreakTime != null
            ? datetimeHelper.msToTime(item.totalBreakTime)
            : item.totalBreakTime;
        item.totalOnlineTime =
          item.totalOnlineTime != null
            ? datetimeHelper.msToTime(item.totalOnlineTime)
            : item.totalOnlineTime;
        item.totalRespiteTime =
          item.totalRespiteTime != null
            ? datetimeHelper.msToTime(item.totalRespiteTime)
            : item.totalRespiteTime;
        item.groups = {};
        for (const groupName in reportGroups) {
          if (reportGroups.hasOwnProperty(groupName)) {
            const value = reportGroups[groupName];
            let foundItemsInGroup = data.filter((i) => {
              let reportGroup = reportGroups[groupName];
              let condition = true;
              if (reportGroup) {
                reportGroup.fields.forEach((field) => {
                  condition &=
                    objectPath.get(i, field) === objectPath.get(item, field);
                });
              }
              return condition;
            });
            let indexInGroup = foundItemsInGroup.indexOf(item);

            item.groups[groupName] = {
              index: indexInGroup,
              count: foundItemsInGroup.length,
            };
          }
        }
      });

      data.unshift(data.pop());

      yield put({
        type: GET_REPORT_AGENT_PERFORMENCE_SUCCESS,
        payload: { ...data },
      });
    } catch (error) {
      yield put({ type: GET_REPORT_AGENT_PERFORMENCE, error });
    }
  }
};

export const getListReportAgentAndGroupPerformenceFlow = function* () {
  while (true) {
    const action = yield take(REPORT_AGENT_AND_GROUP_PERFORMANCE);
    try {
      const res = yield call(
        getListReportAgentAndGroupPerformenceApi,
        action.data.from,
        action.data.to,
        action.data.agentId,
        action.data.agentGroupId
      );
      const data = res.data.sort(function (a, b) {
        var n = Date.parse(b.date) - Date.parse(a.date);
        if (n != 0) {
          return n;
        }
        var m = b.agent.group.localeCompare(a.agent.group);
        if (m != 0) {
          return m;
        }
        return a.agent.code - b.agent.code;
      });
      const reportGroups = {
        date: {
          fields: ["date"],
        },
        dateNTeam: {
          fields: ["date", "agent.group"],
        },
      };
      data.forEach((item) => {
        item.totalTalkingTime =
          item.totalTalkingTime != null
            ? datetimeHelper.secondToHHMMSS(item.totalTalkingTime)
            : item.totalTalkingTime;
        item.acd =
          item.acd != null ? datetimeHelper.secondToHHMMSS(item.acd) : item.acd;
        item.minWrapupTime =
          item.minWrapupTime != null
            ? datetimeHelper.msToTime(item.minWrapupTime)
            : item.minWrapupTime;
        item.maxWrapupTime =
          item.maxWrapupTime != null
            ? datetimeHelper.msToTime(item.maxWrapupTime)
            : item.maxWrapupTime;
        item.avgWrapupTime =
          item.avgWrapupTime != null
            ? datetimeHelper.msToTime(item.avgWrapupTime)
            : item.avgWrapupTime;
        item.totalBreakTime =
          item.totalBreakTime != null
            ? datetimeHelper.msToTime(item.totalBreakTime)
            : item.totalBreakTime;
        item.totalOnlineTime =
          item.totalOnlineTime != null
            ? datetimeHelper.msToTime(item.totalOnlineTime)
            : item.totalOnlineTime;
        item.totalRespiteTime =
          item.totalRespiteTime != null
            ? datetimeHelper.msToTime(item.totalRespiteTime)
            : item.totalRespiteTime;
        item.groups = {};
        for (const groupName in reportGroups) {
          if (reportGroups.hasOwnProperty(groupName)) {
            const value = reportGroups[groupName];
            let foundItemsInGroup = data.filter((i) => {
              let reportGroup = reportGroups[groupName];
              let condition = true;
              if (reportGroup) {
                reportGroup.fields.forEach((field) => {
                  condition &=
                    objectPath.get(i, field) === objectPath.get(item, field);
                });
              }
              return condition;
            });
            let indexInGroup = foundItemsInGroup.indexOf(item);

            item.groups[groupName] = {
              index: indexInGroup,
              count: foundItemsInGroup.length,
            };
          }
        }
      });
      data.unshift(data.pop());
      yield put({
        type: REPORT_AGENT_AND_GROUP_PERFORMANCE_SUCCESS,
        payload: { ...data },
      });
    } catch (error) {
      yield put({ type: REPORT_AGENT_AND_GROUP_PERFORMANCE, error });
    }
  }
};

export const getAgentCallDurationFlow = function* () {
  while (true) {
    const action = yield take(GET_REPORT_AGENT_CALL_DURATION);
    try {
      const res = yield call(
        getAgentCallDurationApi,
        action.data.from,
        action.data.to
      );
      const data = res.data.sort(function (a, b) {
        return a.agent.code - b.agent.code;
      });
      data.forEach((item) => {
        item.percentOneToThree = item.percentOneToThree.toFixed(2);
        item.percentThreeUpto = item.percentThreeUpto.toFixed(2);
        item.percentZeroToOne = item.percentZeroToOne.toFixed(2);
      });
      data.unshift(data.pop());
      yield put({
        type: GET_REPORT_AGENT_CALL_DURATION_SUCCESS,
        payload: { ...data },
      });
    } catch (error) {
      yield put({ type: GET_REPORT_AGENT_CALL_DURATION, error });
    }
  }
};

export const reportAgentInboundFlow = function* () {
  while (true) {
    const action = yield take(REPORT_AGENT_INBOUND);
    try {
      const res = yield call(
        reportAgentInboundApi,
        action.data.from,
        action.data.to,
        action.data.number,
        action.data.groupId
      );
      res.data.sort(function (a, b) {
        var n = Date.parse(b.date) - Date.parse(a.date);
        if (n != 0) {
          return n;
        }
        var m = b.agent.group.localeCompare(a.agent.group);
        if (m != 0) {
          return m;
        }
        return a.agent.code - b.agent.code;
      });
      let data = [["Mã nhân viên", "Trả lời", "Không trả lời", "Nhỡ"]];
      for (const key in res.data) {
        if (res.data.hasOwnProperty(key)) {
          const val = res.data[key];
          if (val.agent.code != "Total") {
            data.push([
              val.agent.code,
              val.answeredCalls,
              val.noAnsweredCalls,
              val.missedCalls,
            ]);
          }
        }
      }
      const reportGroups = {
        date: {
          fields: ["date"],
        },

        dateNTeam: {
          fields: ["date", "agent.group"],
        },
        dateNCode: {
          fields: ["date", "agent.code"],
        },
      };
      res.data.forEach((item) => {
        item.asr = item.asr != null ? item.asr.toFixed(2) : 0;
        item.acd = datetimeHelper.secondToHHMMSS(item.acd);
        item.totalBreakTime = datetimeHelper.secondToHHMMSS(
          item.totalBreakTime / 1000
        );
        item.totalOnlineTime = datetimeHelper.secondToHHMMSS(
          item.totalOnlineTime / 1000
        );
        item.totalRespiteTime = datetimeHelper.secondToHHMMSS(
          item.totalRespiteTime / 1000
        );
        item.totalReadyTime = datetimeHelper.msToTime(item.totalReadyTime);
        item.totalTalkingTime = datetimeHelper.secondToHHMMSS(
          item.totalTalkingTime
        );
        item.msr = item.msr != null ? item.msr.toFixed(2) : 0;
        item.groups = {};
        for (const groupName in reportGroups) {
          if (reportGroups.hasOwnProperty(groupName)) {
            const value = reportGroups[groupName];
            let foundItemsInGroup = res.data.filter((i) => {
              let reportGroup = reportGroups[groupName];
              let condition = true;
              if (reportGroup) {
                reportGroup.fields.forEach((field) => {
                  condition &=
                    objectPath.get(i, field) === objectPath.get(item, field);
                });
              }
              return condition;
            });
            let indexInGroup = foundItemsInGroup.indexOf(item);

            item.groups[groupName] = {
              index: indexInGroup,
              count: foundItemsInGroup.length,
            };
          }
        }
      });
      res.data["reportChart"] = data;
      res.data.unshift(res.data.pop());
      yield put({ type: REPORT_AGENT_INBOUND_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: REPORT_AGENT_INBOUND_ERROR, error });
    }
  }
};
